var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HttpStatusCodes, HttpStatusReasons } from './codes';
var codeToReason = Object.entries(HttpStatusCodes).reduce(function (prev, _a) {
    var key = _a[0], value = _a[1];
    prev[value] =
        HttpStatusReasons[key];
    return prev;
}, {});
/**
 * HTTP error class with status code
 *
 * @example
 * ```
 * // Throw 404 error with default message
 * throw new HttpError(404)
 * throw new HttpError(HttpStatusCodes.NOT_FOUND)
 *
 * // Throw 404 error with custom message
 * throw new HttpError(404, 'X not found')
 * throw new HttpError(HttpStatusCodes.NOT_FOUND, 'X not found')
 *
 * // Throw 500 error and expose custom message to user
 * throw new HttpError(HttpStatusCodes.INTERNAL_SERVER_ERROR, 'Missing configuration', {expose: true})
 *
 * // Handle HttpError
 * if (err instanceof HttpError) {
 *     console.log(err.message)
 *     return err.publicMessage
 * }
 * ```
 * @category Http
 */
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    /**
     * @throws `Error` if status is not supported
     * @param status HTTP [status code](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status)
     * @param message error message, if not provided message from [[HttpStatusReasons]] is used
     * @param properties additional configuration
     */
    function HttpError(status, message, properties) {
        var _a, _b;
        var _this = this;
        if (!(status in codeToReason)) {
            throw new Error('Incorrect status code');
        }
        var defaultMessage = (_a = codeToReason[status]) !== null && _a !== void 0 ? _a : '';
        var privateMessage = message !== null && message !== void 0 ? message : defaultMessage;
        _this = _super.call(this, privateMessage) || this;
        _this.status = status;
        _this.expose = (_b = properties === null || properties === void 0 ? void 0 : properties.expose) !== null && _b !== void 0 ? _b : status < 500;
        _this.publicMessage = _this.expose ? privateMessage : defaultMessage;
        // Fix instanceof bug: https://github.com/microsoft/TypeScript/issues/22585
        Object.setPrototypeOf(_this, HttpError.prototype);
        return _this;
    }
    return HttpError;
}(Error));
export { HttpError };
